import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Slide2 from "../../../images/locationgcc/dxb/industry/pickup.webp";
import Slide3 from "../../../images/locationgcc/dxb/industry/realestate.webp";
import Slide4 from "../../../images/locationgcc/dxb/industry/banking.webp";
import Slide5 from "../../../images/locationgcc/dxb/industry/education.webp";
import Slide6 from "../../../images/locationgcc/dxb/industry/ecommerce.webp";
import Slide7 from "../../../images/locationgcc/dxb/industry/healthcare.webp";
import Slide8 from "../../../images/locationgcc/custom-software/gaming.webp";
import Slide9 from "../../../images/locationgcc/custom-software/entertainment.webp";
import Slide10 from "../../../images/locationgcc/custom-software/lifestyle.webp";
import Slide11 from "../../../images/locationgcc/custom-software/music.webp";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1600 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 1599, min: 1400 },
    items: 3,
  },
  tabletlandscape: {
    breakpoint: { max: 1399, min: 1200 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1199, min: 667 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 666, min: 0 },
    items: 1,
  },
};

const Industrydubai = () => {
  return (
    <div className="industry_gcc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={6} xxl={6} className="my-auto dark_bg">
            <div className="industy_head">
              <h2>
                Custom Software Development For Diverse <span>Industries</span>
              </h2>
              <p>
                Being an industry leader, we keep an eye open for emerging
                technologies essential for software development in a variety of
                industries.
              </p>
              <p>
                TekRevol helps organizations in implementing advanced
                technologies on a large scale. With our proficiency in in-demand
                services like software development and artificial intelligence,
                we empower clients to not just meet but surpass global
                benchmarks within tight deadlines. Whether you're in Saudi
                Arabia or anywhere in the GCC, our goal is to deliver our
                clients the best profitable solutions.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <Carousel
              responsive={responsive}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={3000}
              arrows={false}
              className="carousel_featured"
            >
              <div
                className="industry_item"
                style={{ backgroundImage: `url(${Slide8})` }}
              >
                <h6>Gaming</h6>
              </div>
              <div
                className="industry_item"
                style={{ backgroundImage: `url(${Slide2})` }}
              >
                <h6>Pickup & Delivery</h6>
              </div>
              <div
                className="industry_item"
                style={{ backgroundImage: `url(${Slide3})` }}
              >
                <h6>Real Estate</h6>
              </div>
              <div
                className="industry_item"
                style={{ backgroundImage: `url(${Slide4})` }}
              >
                <h6>Banking & Finance</h6>
              </div>
              <div
                className="industry_item"
                style={{ backgroundImage: `url(${Slide5})` }}
              >
                <h6>Education</h6>
              </div>
              <div
                className="industry_item"
                style={{ backgroundImage: `url(${Slide6})` }}
              >
                <h6>Ecommerce</h6>
              </div>
              <div
                className="industry_item"
                style={{ backgroundImage: `url(${Slide7})` }}
              >
                <h6>Healthcare</h6>
              </div>
              <div
                className="industry_item"
                style={{ backgroundImage: `url(${Slide9})` }}
              >
                <h6>Entertainment</h6>
              </div>
              <div
                className="industry_item"
                style={{ backgroundImage: `url(${Slide10})` }}
              >
                <h6>Lifestyle</h6>
              </div>
              <div
                className="industry_item"
                style={{ backgroundImage: `url(${Slide11})` }}
              >
                <h6>Music</h6>
              </div>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Industrydubai;
